import { HTTPStatuses } from '@packages/domain/constants/http';
import { useQuery } from '@tanstack/react-query';
import {
  FETCH_USER_PAYMENTS_FAILURE,
  FETCH_USER_PAYMENTS_SUCCESS,
} from 'constants/payment';
import { queryKeys } from 'hooks/queryKeys';
import { useEffect } from 'react';
import { payments as paymentsService } from 'services/payex/payments/payments';
import { useDispatch } from 'store/configureStore';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

export const usePayments = ({
  page = 1,
  perPage = 5,
  enabled = true,
}: {
  page?: number;
  perPage?: number;
  enabled?: boolean;
} = {}) => {
  const dispatch = useDispatch();

  const query = useQuery({
    queryKey: queryKeys.userPayments.by(page, perPage),
    queryFn: () => paymentsService.fetchUserPayments({ page, perPage }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({ type: FETCH_USER_PAYMENTS_SUCCESS, payload: query.data });
    }
  }, [query.data, dispatch]);

  useEffect(() => {
    if (query.error) {
      const error = query.error as Error & { status?: HTTPStatuses };
      const isUnauthorized = error.status === HTTPStatuses.UNAUTHORIZED;

      dispatch({ type: FETCH_USER_PAYMENTS_FAILURE, payload: error });

      if (!isUnauthorized) {
        errorNotifier.notifyWithFingerprint(error, [
          FETCH_USER_PAYMENTS_FAILURE,
          error.message,
        ]);
      }
    }
  }, [query.error, dispatch]);

  return query;
};
